import React, { createContext, useContext, useState } from "react";

const ProductionContext = createContext();

export const ProductionProvider = ({ children }) => {
  const [cycleStarted, setCycleStarted] = useState(false);
  const [machineUtilization, setMachineUtilization] = useState(0);
  const [cycleTime, setCycleTime] = useState(null);

  return (
    <ProductionContext.Provider
      value={{
        cycleStarted,
        setCycleStarted,
        machineUtilization,
        setMachineUtilization,
        cycleTime,
        setCycleTime,
      }}
    >
      {children}
    </ProductionContext.Provider>
  );
};

export const useProductionContext = () => useContext(ProductionContext);
